import axios from "axios";
const token = window.localStorage.getItem("token");
const state = {
  templates: [],
};
const getters = {
  GetTemplate: state => state.templates,
};
const actions = {
  async fetchTemplate({ commit }) {
    let response = await axios.get('template')
    commit('setTemplateData', response.data.data)
  },
};
const mutations = {
    setTemplateData(state, templateData) {
        state.templates = templateData;
      }
};
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
